import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Skeleton } from "@mui/material";

const SkeletonTable = ({ displayColumns, displayRows }) => {
  const rows = displayRows || 5;
  const columns = displayColumns || 5;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow
            sx={{
              backgroundColor: "#f5f5f5", // Light gray background
            }}
          >
            {Array.from(new Array(columns)).map((_, index) => (
              <TableCell key={index} sx={{fontWeight: "bold",padding: "10px",}}>
                <Skeleton variant="text" animation="wave" width="100%" height={40} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from(new Array(rows)).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from(new Array(columns)).map((_, colIndex) => (
                <TableCell key={colIndex}>
                  <Skeleton variant="rectangular" height={30} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SkeletonTable;
